export default __webpack_public_path__ + "static/media/forward.bfed6212.svg";